export const themeColors = {
  blue: {
    1: "#cfeaf2",
    2: "#00aed9",
    3: "#018dc0",
    4: "#00619e",
    5: "#045489",
    6: "#183558",
    7: "#122946"
  },
  yellow: {
    1: "#fbf2de",
    2: "#feb948",
    3: "#eb9f23"
  },
  green: {
    1: "#ebfbee",
    2: "#2f9e44",
    3: "#237032"
  },
  red: {
    1: "#fff5f5",
    2: "#e03131",
    3: "#b02525",
    4: "#f65b5b"
  },
  white: "#ffffff",
  black: "#000000",
  grey: {
    1: "#f4f8fa",
    2: "#d9dde9",
    3: "#aab1c7",
    5: "#6d7184"
  },
  special: {
    "marketplace-purple": "#9b51e0"
  }
};
export const themeTokens = {
  color: {
    ...themeColors
  },
  elevation: {
    "0": "none",
    "1": "0px 2px 3px rgba(24, 53, 88, 0.1)",
    "2": "0px 6px 13px rgba(24, 53, 88, 0.1)"
  },
  breakpoint: {
    xs: "0px",
    s: "414px",
    m: "768px",
    l: "1024px",
    xl: "1280px",
    xxl: "1440px"
  },
  font: {
    family: `'Brandon Text', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol'`
  },
  type: {
    brand: {
      all: {
        fontFamily: "Brandon Text",
        textTransform: "uppercase",
        fontWeight: 700
      },
      xl: {
        fontSize: "72px",
        lineHeight: "72px"
      },
      l: {
        fontSize: "54px",
        lineHeight: "54px"
      },
      m: {
        fontSize: "40px",
        lineHeight: "40px"
      },
      s: {
        fontSize: "28px",
        lineHeight: "28px"
      }
    },
    header: {
      all: {
        fontFamily: "Brandon Text",
        fontWeight: 700
      },
      xxl: {
        fontSize: "40px",
        lineHeight: "44px"
      },
      xl: {
        fontSize: "28px",
        lineHeight: "32px"
      },
      m: {
        fontSize: "20px",
        lineHeight: "24px"
      },
      s: {
        fontSize: "16px",
        lineHeight: "20px"
      },
      xs: {
        fontSize: "14px",
        lineHeight: "20px"
      }
    },
    label: {
      all: {
        fontFamily: "Brandon Text",
        textTransform: "uppercase",
        fontWeight: 700
      },
      l: {
        fontSize: "18px",
        lineHeight: "28px"
      },
      m: {
        fontSize: "14px",
        lineHeight: "16px"
      },
      s: {
        fontSize: "12px",
        lineHeight: "16px"
      },
      xs: {
        fontSize: "10px",
        lineHeight: "12px"
      }
    },
    body: {
      all: {
        fontFamily: "Brandon Text",
        fontWeight: 400
      },
      l: {
        fontSize: "18px",
        lineHeight: "28px"
      },
      m: {
        fontSize: "16px",
        lineHeight: "24px"
      },
      s: {
        fontSize: "14px",
        lineHeight: "20px"
      },
      xs: {
        fontSize: "12px",
        lineHeight: "16px"
      }
    },
    link: {
      all: {
        fontFamily: "Brandon Text",
        fontWeight: 400,
        textDecoration: "underline"
      },
      m: {
        fontSize: "16px",
        lineHeight: "24px"
      },
      s: {
        fontSize: "14px",
        lineHeight: "20px"
      }
    }
  },
  border: {
    radius: "3px"
  },
  form: {
    focus: {
      light: {
        boxShadow: `0 0 0 1px white, 0 0 0 3px ${themeColors.blue["3"]}`
      },
      dark: {
        boxShadow: `0 0 0 1px ${themeColors.blue["3"]}, 0 0 0 3px white`
      }
    }
  }
};
export const typeStyle = (name = "-", theme = themeTokens) => {
  const [textName, textSize] = name?.split("-");
  const { type } = theme;
  const textType = type[textName?.toLowerCase()] || {};
  return {
    ...textType.all,
    ...textType[textSize]
  };
};
export const focusStyle = (name = "light", theme = themeTokens) => {
  const { form } = theme;
  const focusStyles = form?.focus || {};
  const styleObj = focusStyles[name.toLowerCase()] || {};
  return styleObj;
};
export const mediaQuery = (name = "m", theme = themeTokens) => {
  const alias = {
    "small-mobile": "xs",
    "tablet-portrait": "s",
    "tablet-landscape": "m",
    laptop: "l",
    desktop: "xl",
    "large-desktop": "xxl"
  };
  const useName = alias[name] || name;
  const { breakpoint } = theme;
  const bp = breakpoint[useName] || "";
  return `@media (min-width: ${bp})`;
};
export const hexToRgb = (input) => {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const hex = input.replace(shorthandRegex, (m, r, g, b) => {
    return r + r + g + g + b + b;
  });
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : {};
};
